import { useDispatch, useSelector } from "react-redux"
import { State } from "../reducers"
import { REGEX_LETRAS_ESPACIOS } from "../constants/Regex"
import * as http from '../api/http'
import { ENDPOINTS } from "../api/config"
import { KEYS } from "../constants/keysStorage"
import { generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalOpenToastError, generalShowLoader, getFechaHora } from "./general.actions"
import { useEffect } from "react"

import FlechaDerechaIcon from '../media/felsv/white_right-arrow_icon.svg'
import EmitirIcon from '../media/felsv/white_check_icon.svg'
import MasOpcionesIcon from '../media/felsv/WhiteOpciones.svg'
import { unirChipsJoin, validarRegexLetras, validarRegexNumericoFloat2Decimales, validarRegexNumericoInt } from "../utils/strings.utils"
import { getMunicipios } from "./catalogos.actions"
import { facturacionGetUUID } from "./facturacion/facturacionEmision.actions"
import { convertDateFormatAnular, getFechaCA, getFechaFormato1, getMinDateRetroactiva, convertirFechaParaFechaDoc } from "../utils/stringDate"
import { anularFactura_DTE, descargarJson, generateQRImageFromBits, getExcelFactura, getFacturaImage, getFacturaPDF_New, getQR, sendTransactionEmail } from "./operaciones/operaciones.actions"
import { useHistory } from "react-router-dom"
import { OPSendEmail } from "../interfaces/operaciones.interface"
import { ActionNC, NCProducto } from "../interfaces/nota-credito.interface"
import { NOTA_CREDITO_TYPES } from "../constants/nota-credito.types"
import { getTransactions } from "./historial/historialFilter.actions"
import { formatearNum } from "../pages/DetalleFactura/Components/VisualizacionFactura/TotalesDetalle"
import { showMessageSucursalVacia } from "./userLogin.actions"
import { docsDatosReceptorReset, docsDatosReceptorSiguienteDispatch } from "./documentos/documentos.actions"
import { handleRestartStateFormaPago } from "./forma-pago.actions"
import useUtilsDocs from "./utils-documentos.actions"

export default function useNotaCredito (){
    const dteCode = "05";
    const {formCliente, formProducto, errorsCliente, errorsProducto, productos, view, productoEdit, productoIndex, response_Emitir, totalOriginal, formObservaciones} = useSelector((state: State) => state.notaCredito)
    const {departamentos, datosEmisor, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)
    const {DetallesDTE, TipoContribuyenteReceptor, idserviciodte, detallenota, pagina} = useSelector((state: State) => state.historial.activeFactura)
    const {formFilter} = useSelector((state: State) => state.historial)
    const {datos, config} = useSelector((state: State) => state.userLogin)
    const {unidadesMedida} = useSelector((state: State) => state.catalogos)
    const datosReceptor = useSelector((state: State) => state.documentos.datosReceptor.form);
    const {datosUUID} = useSelector((state: State) => state.facturacion)
    const emisorGranContribuyente = datosEmisor?.tipoContribuyente === '1'
    const emisorJuridico = datosEmisor?.tipoEmpresa === '1'
    const receptorGranContribuyente = TipoContribuyenteReceptor === 'true'
    const dispatch = useDispatch()
    const history = useHistory()

    const {getTributosCatalogoProducto, procesOtrosImpuestosResumen, processOtrosImpuestosCalculo} = useUtilsDocs();
    
    const cargarDatosIniciales = () => {
        let fechaActual = new Date().toISOString().split('T')[0]
        let sucursalConDocumento = formCliente?.datosSucursal?.find((suc: any) => suc.Documento.find((doc: any) => doc.iddocumento === '5'))
        let documentoSucursal = sucursalConDocumento?.Documento.find((doc: any) => doc.iddocumento === '5')

        dispatch(handleSetFormCliente({
            ...formCliente,
            fecha: (config?.facturacion_retroactiva && formCliente.fecha) ? formCliente.fecha : fechaActual,
            sucursal: sucursalConDocumento?.idsucursal,
            serie: documentoSucursal?.idsucursaldocumento
        }))

        const nombreDepartamento = departamentos.find(departamento => departamento.codigo === DetallesDTE.receptor.direccion.departamento)?.valor
        dispatch(getMunicipios(parseInt(DetallesDTE.receptor.direccion.departamento), nombreDepartamento, false))
    }

    const cargarProductosIniciales = () => {
        if (productos.length === 0) {
            dispatch(generalShowLoader(true));

            let listadoProductosBase:Array<any> = DetallesDTE?.cuerpoDocumento.map((producto: any) => {

                const productoBase = {
                    id: Math.floor(Math.random() * 900000) + 100000,
                    cantidad: producto.cantidad,
                    // Si trae descuento, restarle al precio unitario el descuento por item
                    precio:
                        (producto.montoDescu > 0)
                        ? (producto.precioUni - (producto.montoDescu / producto.cantidad)) //parseFloat((producto.precioUni - (producto.montoDescu / producto.cantidad)).toFixed(2))
                        : (producto.ventaGravada > 0) ? (producto.ventaGravada / producto.cantidad)
                        : (producto.ventaExenta > 0) ? (producto.ventaExenta / producto.cantidad)
                        : (producto.noGravado > 0) ? (producto.noGravado / producto.cantidad)
                        : (producto.ventaNoSuj / producto.cantidad),
                    descuento: 0,
                    tipoDescuento: 'Monto',
                    descripcion: producto.descripcion,
                    conIva: false,
                    servicio: producto.TipoProducto === "0",
                    exento: producto.TipoMonto === "1",
                    noSujeto: producto.TipoMonto === "2",
                    noGravado: producto.TipoMonto === "3",
                    servicioDescuento: false,
                    unidadMedida: `${producto.uniMedida}`?.padStart(2, '0') || '59',
                    clave: producto.codigo,
                    tributos: getTributosCatalogoProducto(producto.codigo)
                }

                return {
                    ...productoBase,
                    original: productoBase // Guardar original
                }
            });

            // Ver diferencias por nota
            var notas:Array<any> = detallenota || [];
            // Ordenar por fecha
            if (notas.length > 0) {
                const dteOrdenados = detallenota.map((el: any) => {
                    const fechaCompleta = new Date(`${el.DetallesDTE?.identificacion?.fecEmi}T${el.DetallesDTE?.identificacion?.horEmi}`);
                    return { ...el, fechaCompleta };
                });
                notas = dteOrdenados.sort((a:any, b:any) => a.fechaCompleta - b.fechaCompleta);
            }

            for(const nota of notas) {
                // Si esta anulado ignorarlo
                if (nota.anulado === "true") { continue; }

                const productosNota = nota?.DetallesDTE?.cuerpoDocumento ?? [];
       
                if (nota.tipo_dte == "5") {    
                    // NOTAS DE CREDITO
                    // Indices a eliminar
                    let eliminarIndex: number[] = [];

                    // Recorrer productos base
                    for (let i = 0; i < listadoProductosBase.length; i++) {
                        const productoBase = listadoProductosBase[i];
                        const productoAnotado = productosNota.find((item: any) => item.descripcion === productoBase.descripcion && item.servicioDescuento === "0");
                        let precioIgual, cantidadIgual, descuentoIgual = false;

                        // Si no esta el producto continuar iterando
                        if (!productoAnotado) { continue; }
               
                        // Caso 1 - Quito items
                        if (productoBase.cantidad !== productoAnotado?.cantidad) {
                            productoBase.cantidad -= productoAnotado.cantidad;
                        } else { cantidadIgual = true }

                        // Caso 2 - Redujo el precio o aplico descuento
                        if (productoBase.precio !== productoAnotado.precioUni) {
                            productoBase.precio = (productoBase.precio - productoAnotado.precioUni) //parseFloat((productoBase.precio - productoAnotado.precioUni).toFixed(2))
                        } else { precioIgual = true }

                        // Caso 3 - Todo el producto
                        if (cantidadIgual && precioIgual) {
                            eliminarIndex.push(i);
                        }

                        // Actualizar producto original
                        productoBase.original = {...productoBase, original: null};
                    }

                    // Eliminar productos si aplico caso 3 y si se quedo sin cantidad
                    listadoProductosBase = 
                        listadoProductosBase.filter((prod:any, index:number) => 
                            !eliminarIndex.includes(index) || prod.cantidad === 0
                    );

                    // Comprobar si hay servicios de descuentos
                    const serviciosDescuentos = productosNota.filter((item: any) => item.servicioDescuento === "1");
                    let eliminarIndexDescuento: number[] = [];

                    for(const descuento of serviciosDescuentos) { 
                        var descuentoActual = descuento.precioUni;
                        // Iterar productos actuales
                        for (let i = 0; i < listadoProductosBase.length; i++) {
                            const productoBase = listadoProductosBase[i];
                            const totalProducto = (productoBase.precio * productoBase.cantidad) - productoBase.descuento;

                            if (descuentoActual > totalProducto) {
                                // Supera el total del producto - Eliminarlo
                                eliminarIndexDescuento.push(i);
                                descuentoActual -= totalProducto;
                            } else {
                                // No lo supera agregar como descuento en el item
                                productoBase.descuento += descuentoActual;
                                break;
                            }
                        }
                    }

                    // Eliminar productos si es mayor el descuento
                    listadoProductosBase = 
                        listadoProductosBase.filter((prod:any, index:number) => 
                            !eliminarIndexDescuento.includes(index) && (((prod.precio * prod.cantidad) - prod.descuento) > 0));
                } 

                else if (nota.tipo_dte == "6") {
                    // NOTAS DE DEBITO
                    // Agregar item
                    productosNota.forEach((itemProducto: any) => {
                        const nuevoItem = {
                            id: Math.floor(Math.random() * 900000) + 100000,
                            cantidad: itemProducto.cantidad,
                            precio: (itemProducto.montoDescu > 0) 
                                ? (itemProducto.precioUni - (itemProducto.montoDescu / itemProducto.cantidad)) //parseFloat((itemProducto.precioUni - (itemProducto.montoDescu / itemProducto.cantidad)).toFixed(2))
                                : (itemProducto.ventaGravada > 0) ? (itemProducto.ventaGravada / itemProducto.cantidad)
                                : (itemProducto.ventaExenta > 0) ? (itemProducto.ventaExenta / itemProducto.cantidad)
                                : (itemProducto.ventaNoSuj / itemProducto.cantidad),
                            descuento: 0,
                            tipoDescuento: 'Monto',
                            descripcion: itemProducto.descripcion,
                            servicio: itemProducto.TipoProducto === "0",
                            exento: itemProducto.TipoMonto === "1",
                            noSujeto: itemProducto.TipoMonto === "2",
                            conIva: false,
                            servicioDescuento: false,
                            unidadMedida: `${itemProducto.uniMedida}`?.padStart(2, '0') || '59',
                            clave: itemProducto.codigo,
                            tributos: getTributosCatalogoProducto(itemProducto.codigo),
                        }
                        listadoProductosBase.push({
                            ...nuevoItem,
                            original: nuevoItem
                        });
                    })
                }
            }

            // Excluir ítems No Gravados: Hacienda no contempla esta categoría en NC (tipoDte 05)
            listadoProductosBase = listadoProductosBase.filter((p: any) => !p.noGravado);

            // Validar saldo restante
            if (listadoProductosBase.length === 0) {
                dispatch(generalShowLoader(false));
                dispatch(generalOpenModalInfo("El documento seleccionado ya no contiene saldo para una generar una nueva nota de crédito."));
                history.push('/history-invoice?reload=0');
                return;
            }

            // Setear productos actuales
            dispatch(handleAddProducto(listadoProductosBase.map((prod) => ({
                ...prod,
                cantidad: `${prod.cantidad}`,
                precio: `${prod.precio}`,
                descuento: `${prod.descuento}`,
            }))));
            dispatch(generalShowLoader(false));
        }
    }

    const button_onBack = () => {
        dispatch(handleAddProducto([]));
        dispatch(handleSetTotalOriginal(0));  
    }

    const onChangeFormCliente = (field: string, value: any) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        if (field === 'sucursal') {
            dispatch(handleSetFormCliente({...formCliente, 'serie': '', [field] : value}))
        } else {
            dispatch(handleSetFormCliente({...formCliente, [field] : value})) 
        }
        validateFormCliente(field, value)
    }

    const validateFormCliente = (field: string, value: string) => {
        let message = ''
        switch (field) {
            case 'sucursal':
                if (!value) {message = 'Sucursal es requerida';}
                break;

            case 'serie':
                if (!value) {message = 'Serie es requerida';}
                break;

            default:
                break;
        }

        dispatch(handleErrorsFormCliente({
            ...errorsCliente,
            [field] : message
        }))

        return (message)
    }

    const onChangeFormProducto = (field: string, value: any) => {
        if(!validateChange(field, value) && value.trim() !== '') return
        dispatch(handleSetFormProducto({...formProducto, [field] : value}))
        validateFormProducto(field, value)
    }

    const validateFormProducto = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) <= 0){message = 'El precio debe ser mayor a 0.'; break;}
                break;
        }
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))

        return (message)
    }

    const validateFormProductoEdit = (field: string, value: string) => {
        let message = ''
        
        switch(field){
            case 'descripcion':
                if(value.trim() === ''){message = 'Descripción es obligatoria.'; break;}
                break;
            case 'cantidad':
                if(value.trim() === '' || parseFloat(value) === 0) {message = 'La cantidad debe ser mayor a 0.'; break;}
                else if (parseFloat(value) > parseFloat(productoEdit.original?.cantidad)) {message = `La cantidad no debe ser mayor a la original (${productoEdit.original.cantidad})`; break; }
                break;
            case 'precio':
                if(value.trim() === '' || parseFloat(value) <= 0){message = 'El precio debe ser mayor a 0.'; break;}
                else if (parseFloat(value) > parseFloat(productoEdit.original?.precio)) {message = `El precio no debe ser mayor al original ($${productoEdit.original.precio})`; break; }
                break;
            case 'descuento':
                if (!productoEdit.servicioDescuento) {
                    let suma = parseFloat(productoEdit.cantidad) * parseFloat(productoEdit.precio)
                    if(parseFloat(value) > 100 && productoEdit.tipoDescuento === 'Porcentaje') {message = 'El porcentaje de descuento no puede ser mayor al 100%.'; break;}
                    if(productoEdit.tipoDescuento === 'Monto'){
                        if(parseFloat(value) > suma){message = 'El monto de descuento no puede ser mayor al precio.'; break;}
                    }
                }
                break;
        }

        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            [field] : message
        }))
        
        return (message)
    }

    const validateChange = (field: string, value: string) => {
        switch(field){
            case 'nombre':
                return (REGEX_LETRAS_ESPACIOS.test(value))
            case 'descripcion':
                    return validarRegexLetras(value);
            case 'cantidad':
                    return validarRegexNumericoInt(value);
            case 'precio':
                    if(parseFloat(value) > 100000000000) return
                    return validarRegexNumericoFloat2Decimales(value);
            case 'descuento':
                    if(parseFloat(value) > 100000000000) return
                    return validarRegexNumericoFloat2Decimales(value);
            case 'noDocumento':
                    switch (formCliente.tipoDocumento){
                        case '36':
                            if(value.length > 14) return false
                            return(validarRegexNumericoInt(value))
                    }
                break;
            case 'nrc':
                return (!(value.length > 7))
            default:
                return true
        }
    }

    const cargarSucursales = async() => {
        try {
            let message = 'No se logró obtener el catalogo de sucursales'
            const response: any = await api_getSucursales({
                idsucursal: `${datos.sucursal_seleccionada}`,
                tipodocumento: '05'
            })

            if (response.body && !response.message) {
                const sucursal = response.body;
                const hayDocs = sucursal[0]?.Documento?.length;
                dispatch((d: any, getState: any) => {
                    d(handleSetFormCliente({...getState().notaCredito.formCliente, datosSucursal: hayDocs ? sucursal : [], loadedSucursal: true}))
                })
            } else {
                dispatch(generalOpenModalError(response.message || message))
            }
        } catch (error: any) {
            if(error?.response?.data?.errorCode === 1) {
                dispatch((d: any, getState: any) => {
                    d(handleSetFormCliente({...getState().notaCredito.formCliente, datosSucursal: [], loadedSucursal: true}))
                })
                return;
            }
            dispatch(generalOpenModalError(error?.response?.data?.message ?? 'Error al obtener las sucursales', error?.response?.data?.status))
        }
    }

    const button_onClickLimpiarFormProducto = () => {
        dispatch(handleRestartFormProducto())
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
    }

    const button_onClickAgregarProducto = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(formProducto).forEach((key) => {
            if (validateFormProducto(key, formProducto[key])){
                let propiedad = key
                let value = validateFormProducto(key, formProducto[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa el formulario de producto'))
            return;
        }

        if(productos.filter((prod) => !prod.servicioDescuento).length > 0) {
            dispatch(generalOpenModalInfo('Para agregar un descuento, es necesario primero eliminar todos los productos actuales.'))
            return;
        }

        let tempArray = productos
        tempArray.push({
            ...formProducto, id: Math.floor(Math.random() * 900000) + 100000,
            cantidad: '1',
            servicio: false,
            exento: false,
            conIva: false,
            descuento: '0',
            servicioDescuento: true,
            original: null,
        })
        dispatch(handleAddProducto(tempArray))     
        dispatch(generalOpenModalInfo('Producto agregado correctamente.'))   
        dispatch(handleRestartFormProducto())
    }

    const footer_onClickNext = async() => {
        switch (view) {
            case 'Formularios':
                let errors: { [key: string]: string } = {};

                Object.keys(formCliente).forEach((key) => {
                    if (validateFormCliente(key, formCliente[key])){
                        let propiedad = key
                        let value = validateFormCliente(key, formCliente[key])
                        errors[propiedad] = value
                    }
                })
                dispatch(handleErrorsFormCliente({
                    ...errorsCliente,
                    ...errors
                }))

                if(Object.values(errors).some((err) => err !== '')){
                    dispatch(generalOpenModalInfo('Revisa los datos del formulario'))
                    return;
                }

                if(productos.length === 0){
                    dispatch(generalOpenModalInfo('En este momento, no es posible crear una nota de crédito ya que no contamos con productos disponibles. Si consideras que esto es un error, por favor reinicia el proceso.'))
                    return;
                }

                if(calculosProducto().total > totalOriginal){
                    dispatch(generalOpenModalInfo(`El total actual de <b>${formatearNum(calculosProducto().total)}</b> excede el monto permitido de <b>${formatearNum(totalOriginal)}</b> del documento original. Por favor, ajusta el monto para no superarlo.`))
                    return;
                }

                const datosRec:any = dispatch(docsDatosReceptorSiguienteDispatch())
                if(datosRec === true) return;

                if(calculosProducto().total >= 2147483647){
                    dispatch(generalOpenToastError('Las operaciones que intentas realizar estàn fuera del lìmite permitido'))
                    return;
                }

                try {
                    dispatch(generalShowLoader(true))
                    await Promise.all([
                        dispatch(facturacionGetUUID('05', false))
                    ])
                } finally {
                    dispatch(generalShowLoader(false))
                }
                dispatch(handleChangeView('Previsualizacion'))
                break;
            case 'Previsualizacion':
                dispatch(handleActiveModalEmitir(true))
                break;
            case 'Detalle':
                dispatch(handleActiveModalMasOpciones(true))
                dispatch(handleRestartStateFormaPago())
                break;
        }
    }

    const footer_onClickBack = () => {
        switch (view) {
            case 'Formularios':
                if(productos.length > 0) dispatch(handleActiveModalQuitarTodo(true))
                break;
            case 'Previsualizacion':
                dispatch(handleChangeView('Formularios'))
                break;
            case 'Detalle':
                dispatch(handleRestarFlujoCredito())
                dispatch(docsDatosReceptorReset())
                break;
        }
    }

    const footer_textButtons = () => {
        let textBack = ''
        let textNext = ''
        let iconBack = ''
        let iconNext = ''
        switch(view){
            case 'Formularios':
                textBack = 'Quitar todo'
                textNext = 'Siguiente'
                iconBack = ''
                iconNext = FlechaDerechaIcon
                break;
            case 'Previsualizacion':
                textBack = 'Anterior'
                textNext = 'Emitir'
                iconBack = ''
                iconNext = EmitirIcon
                break;
            case 'Detalle':
                textBack = ''
                textNext = 'Más opciones'
                iconBack = ''
                iconNext = MasOpcionesIcon
                break;
        }

        return {
            next: {
                text: textNext,
                icon: iconNext
            },
            back: {
                text: textBack,
                icon: iconBack
            }
        }
    }

    const button_onClickQuitarTodo = () => {
        dispatch(handleAddProducto([]))
        modal_cerrarQuitarTodo()
        dispatch(generalOpenModalInfo('Se eliminaron todos los productos de la lista'))
    }

    const actionButton_editar = (producto: NCProducto) => {
        let tempForm: { [key: string]: any } = {
            ...productoEdit,
            ...producto,
        }
        let errors: { [key: string]: string } = {};

        Object.keys(tempForm).forEach((key) => {
            if (validateFormProducto(key, tempForm[key])){
                let propiedad = key
                let value = validateFormProducto(key, tempForm[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errors
        }))

        dispatch(handleSetIndexProductoEdit(producto.id))
        dispatch(handleActiveModalEditar(true))
        dispatch(handleSetProductoEdit(producto))
    }
    
    const modal_cerrarModalEditar = () => {
        button_onClickLimpiarFormProducto()
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEditar(false))
        dispatch(handleSetProductoEdit({
            ...productoEdit,
            descripcion: '',
            cantidad: '',
            precio: '',
            descuento: ''
        }))
        
    }

    const actionButton_eliminarProducto = (index: any) => {
        dispatch(handleSetIndexProductoEdit(index))
        dispatch(handleActiveModalEliminar(true))
    }
    
    const modal_button_onConfirmEliminar = () => {
        dispatch(handleAddProducto(productos.filter((prod) => prod.id !== productoIndex)))
        dispatch(generalOpenModalInfo('Producto eliminado exitosamente.'))
        modal_cerrarModalEliminar()
    }
    
    const modal_cerrarModalEliminar = () => {
        dispatch(handleSetIndexProductoEdit(null))
        dispatch(handleActiveModalEliminar(false))
    }

    const modal_onChangeFormProductoEdit = (field: string, value: string) => {
        if(!validateChange(field, value) && value.trim() !== '') return

        dispatch(handleSetProductoEdit({
            ...productoEdit,
            [field] : value
        }))

        validateFormProductoEdit(field, value)
    }

    const modal_button_onConfirmEdit = () => {
        let errors: { [key: string]: string } = {};

        Object.keys(productoEdit).forEach((key) => {
            if (validateFormProductoEdit(key, productoEdit[key])){
                let propiedad = key
                let value = validateFormProductoEdit(key, productoEdit[key])
                errors[propiedad] = value
            }
        })
        dispatch(handleErrorsFormProducto({
            ...errorsProducto,
            ...errors
        }))

        if(Object.values(errors).some((err) => err !== '')){
            dispatch(generalOpenModalInfo('Revisa los datos del producto'))
            return;
        }

        dispatch(handleAddProducto(productos.map((prod) => (prod.id === productoIndex) ? {...productoEdit} : prod)))
        modal_cerrarModalEditar()
        dispatch(generalOpenModalInfo('Producto actualizado exitosamente.'))
    }

    const modal_cerrarQuitarTodo = () => {
        dispatch(handleActiveModalQuitarTodo(false))
    }

    const modal_cerrarEmitir = () => {
        dispatch(handleActiveModalEmitir(false))
    }

    const modal_button_emitirNuevo = async() => {
        dispatch(handleAddProducto([]))
        dispatch(handleRestartStateFormaPago())
        await dispatch(handleRestarFlujoCredito())
        dispatch(docsDatosReceptorReset())
        await dispatch(handleSetFormCliente(
            {
                fecha: '',
                tipoDocumento: '',
                noDocumento: '',
                nombre: '',
                departamento: '',
                municipio: '',
                direccion: '',
                email: '',
                telefono: '',
                actividad: '',
                actividadDescripcion: '',
                departamentoDescripcion: '',
                municipioDescripcion: '',
                nrc: '',
                
                datosSucursal: [],
                datosDocumento: [],
        
                sucursal: '',
                serie: '',
                loadedSucursal: false,
            }
        ))
        await dispatch(handleAddProducto([]))
        setTimeout(() => {
            history.push('/history-invoice?reload=0')
            dispatch(handleChangeView('Formularios'))
        }, 2)
        dispatch(handleAddProducto([]))
    }

    const modal_button_verDetalle = () => {
        dispatch(handleChangeView('Detalle'))
        dispatch(handleActiveModalEmitido(false))
        modal_cerrarEmitir()
    }

    const modal_cerrarMasOpciones = () => {
        dispatch(handleActiveModalMasOpciones(false))
        dispatch(handleActiveModalEmitido(false))
    }

    const modal_button_cerrarModalEmitido = () => {
        dispatch(handleRestartStateFormaPago())
        dispatch(handleRestarFlujoCredito())
        dispatch(docsDatosReceptorReset())
        dispatch(handleAddProducto([]))
        dispatch(handleActiveModalEmitido(false))
        history.push('/otros-documentos')
    }

    const modal_button_enviarCorreo = () => {
        dispatch(handleActiveModalCorreo(true))
    }

    const modal_button_cerrarEnviarCorreo = () => {
        dispatch(handleActiveModalCorreo(false))
    }

    const modal_button_descargarExcel = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getExcelFactura(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el Excel.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarImagen = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaImage(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.codigoGeneracion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar la imagen.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarPDF = async() => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaPDF_New(
                {
                    Documento: response_Emitir.JsonFactura,
                    Sello: response_Emitir.Sello,
                },
                response_Emitir.serie,
                response_Emitir.estadoanulacion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el PDF.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_imprimir = () => {
        dispatch(handleActiveModalImprimir(true))
    }

    const modal_cerrarImprimir = () => {
        dispatch(handleActiveModalImprimir(false))
    }

    const modal_button_imprimirTicket = () => {
        dispatch(handleActiveModalImprimir(true))
    }

    const modal_button_descargarPDFTicket = async () => {
        try {
            dispatch(generalShowLoader(true))
            await dispatch(getFacturaPDF_New(
                { Documento: response_Emitir.JsonFactura, Sello: response_Emitir.Sello, ModoTicket: true },
                response_Emitir.serie, response_Emitir.estadoanulacion
            ))
        } catch (error) {
            dispatch(generalOpenModalError('Ocurrió un error al descargar el Ticket PDF.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_onClickEnviarCorreo = async(email: string) => {
        try {
            dispatch(generalShowLoader(true))
            const sendEmail: OPSendEmail = {
                Correo: email,
                CorreoCC: formCliente?.correocc?.trim() || DetallesDTE?.receptor?.correocc?.trim() || '',
                Documento: response_Emitir.JsonFactura,
                Sello: response_Emitir.Sello,
                json: response_Emitir?.JsonFacturaFile || "",
                idSucursal: datos?.sucursal_seleccionada,
                idEmpresa: `${datos?.codigo_empresa}`
            }
            const res:any = await dispatch(sendTransactionEmail(sendEmail))
            if(res){
                dispatch(generalOpenModalMessage('Enviar por correo electrónico', 'El correo electrónico fue enviado exitosamente.'))
                return true;
            }
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.message || 'Ocurrió un error al enviar el correo'))
            return false
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_descargarJson = () => dispatch(descargarJson({idFactura: response_Emitir?.codigoGeneracion, json: response_Emitir?.JsonFacturaFile}))

    const modal_button_anular = () => {
        dispatch(handleActiveModalAnular(true))
    }

    const modal_cerrarAnular = () => {
        dispatch(handleActiveModalAnular(false))
    }

    const modal_button_onConfirmAnular = async() => {
        dispatch(generalShowLoader(true))

        try {
            //------------------------
            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            let ivaTotal = 0
            productos.forEach((producto) => {
                let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                let ivaProducto = (precioUnitario * 0.13) * parseFloat(producto.cantidad)
                if(!producto.exento && !producto.noSujeto){
                    ivaTotal += ivaProducto
                }
            })
            //------------------------
            const receptor = DetallesDTE.receptor;

            const anularDoc = {
              documento: response_Emitir.JsonFactura,
              sellorecibido: response_Emitir.Sello,
              DetallesDTE: {
                receptor: {
                  numDocumento: receptor.nit,
                  tipoDocumento: '36',
                  nrc: receptor.nrc,
                  nombre: receptor.nombre,
                  telefono: receptor.telefono,
                  correo: receptor.correo,
                },
                emisor: {
                  nombre: datosEmisor.nombre,
                  nit: datosEmisor.nit,
                  nrc: datosEmisor.nrc,
                  telefono: datosEmisor.telefono,
                  correo: datosEmisor.correo,
                  tipoEstablecimiento: datosEmisor.tipoestablecimiento,
                },
                resumen: {
                  totalIva: isNaN(ivaTotal) ? '0' : `${ivaTotal.toFixed(2)}`,
                },
                identificacion: {
                  tipoDte: '05',
                  codigoGeneracion: response_Emitir.codigoGeneracion,
                  numeroControl: `DTE-05-${serie}`,
                  fecEmi: convertDateFormatAnular(response_Emitir.fhProcesamiento.split(' ')[0]),
                  IDsucursalDoc: documento.idsucursaldocumento
                },
              },
            }
            const response: any = await dispatch(anularFactura_DTE(anularDoc))
            if(response){
                dispatch(getTransactions(formFilter, pagina, true));
                dispatch(generalOpenModalInfo('Documento anulado exitosamente'))
                modal_button_emitirNuevo()
            }
        } catch (error: any) {
            dispatch(generalOpenModalError(error?.response?.data?.body?.descripcionMsg || 'Ocurrió un error al anular el documento.'))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const modal_button_emitirDocumento = async() => {
        dispatch(generalShowLoader(true))
        const horasActuales:any = await dispatch(getFechaHora());
        let fechaDoc: string
        if (
          config?.facturacion_retroactiva &&
          config?.dias_facturacion_retroactiva &&
          horasActuales &&
          formCliente?.fecha &&
          formCliente.fecha <= horasActuales.FechaInput
        ) {
          const minDate = getMinDateRetroactiva(config.dias_facturacion_retroactiva, horasActuales.FechaInput)
          if (formCliente.fecha < minDate) {
            dispatch(generalOpenModalError(`La fecha seleccionada excede el límite de ${config.dias_facturacion_retroactiva} días retroactivos permitidos.`))
            dispatch(generalShowLoader(false))
            return
          }
          fechaDoc = `${convertirFechaParaFechaDoc(formCliente.fecha)} ${horasActuales.Hora}`
        } else {
          fechaDoc = horasActuales ? `${horasActuales.FechaDDMM} ${horasActuales.Hora}` : `${getFechaFormato1()} ${new Date().toLocaleTimeString([], {hour: '2-digit', minute: '2-digit', second: '2-digit'})}`
        }
        try{
            // -----------------------------------------------------------------
            let sumaOperaciones = 0
            let iva = 0
            let subtotal = 0
            let ivaPercibido = 0
            let ivaRetenido = 0
            let retencionRenta = 0
            let descuentoTotal = 0
            let total = 0
            let otrosImpuestos = 0
            let resumenTributos:Array<any> = [];

            productos.forEach((producto) => {
                let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
                let descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (precioUnitario * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad) : parseFloat(producto.descuento)
                let ivaProducto = ((precioUnitario * parseFloat(producto.cantidad)) - descuento) * 0.13

                const precio = (precioUnitario * parseFloat(producto.cantidad)) - descuento;
                sumaOperaciones += precio;
                otrosImpuestos += processOtrosImpuestosCalculo(dteCode, producto, precio, false);
                resumenTributos = procesOtrosImpuestosResumen(dteCode, resumenTributos, producto, precio);

                if(!producto.exento && !producto.noSujeto){
                    iva += ivaProducto
                    subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento) + ivaProducto
                } else {
                    subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
                }
                descuentoTotal += descuento
            })
            
            resumenTributos.forEach((resum) => {
                resum.valor = parseFloat(resum.valor.toFixed(2));
            });

            if(emisorGranContribuyente && !receptorGranContribuyente && sumaOperaciones >= 100){
                ivaPercibido = sumaOperaciones * 0.01
            }
        
            if(!emisorGranContribuyente && receptorGranContribuyente && sumaOperaciones >= 100){
                productos.forEach((producto) => {
                    if (!producto.exento && !producto.noSujeto) {
                        ivaRetenido += (parseFloat(producto.precio) * 0.01) * parseFloat(producto.cantidad)
                    }
                })
            }

            subtotal += otrosImpuestos;
            total = subtotal + ivaPercibido - ivaRetenido - retencionRenta;

            let documento = formCliente?.datosSucursal?.find((sucursal: any) => sucursal?.idsucursal === formCliente?.sucursal)?.Documento?.find((doc: any) => doc?.idsucursaldocumento === formCliente?.serie)
            let serie = `${documento?.serie}-${documento?.numeroactual}`
            const receptor = DetallesDTE.receptor;

            let body: any = {
                idserviciodte: idserviciodte,
                id_user: localStorage.getItem(KEYS.ID_CLIENT),
                facturas: 
                [{
                    receptorEmailsEnvio: receptor.correo,
                    receptorManual: datosReceptor.nombre,
                    docManual: datosReceptor.numId,
                    esReceptorManual : datosReceptor.esReceptorManual,
                    tipoDocManual : datosReceptor.nombreTipoDocumento,
                    idsucursaldocumento: formCliente.serie,
                    tipoDte: "05",
                    cveDoc: serie,
                    uuid: datosUUID?.CodigoGeneracion,
                    docAnt: DetallesDTE?.identificacion?.numeroControl,
                    fechaDoc: fechaDoc,
                    canTotal: `${sumaOperaciones.toFixed(6)}`,
                    impuTotal: `${iva.toFixed(6)}`,
                    impuTotal2: !emisorGranContribuyente && receptorGranContribuyente && sumaOperaciones >= 100 ? `${ivaRetenido.toFixed(6)}` : '0',
                    impuTotal3: emisorGranContribuyente && !receptorGranContribuyente && sumaOperaciones >= 100 ? `${ivaPercibido.toFixed(6)}` : '0',
                    descuentoTotal: `${descuentoTotal.toFixed(6)}`,
                    retencionRenta: `${retencionRenta.toFixed(6)}`,
                    condicion: `${formCliente.condicion}`,
                    receptor: {
                        rfc: receptor.nit,
                        nit: receptor.nit,
                        nombre: receptor.nombre,
                        direccion: receptor.direccion.complemento,
                        email: receptor.correo,
                        telefono: receptor.telefono,
                        nrc: receptor.nrc,
                        correocc: receptor.correocc?.trim() || formCliente?.correocc?.trim() || '',
                        codActividad: receptor.codActividad,
                        descAtvividad: receptor.descActividad,
                        departamento: receptor.direccion.departamento,
                        municipio: receptor.direccion.municipio,
                    },
                    docRelacionado: [
                        {
                            tipoDocumento: '03',
                            tipoDocRelDesc: 'Comprobante de crédito fiscal',
                            numeroDocumento: DetallesDTE?.identificacion?.codigoGeneracion,
                            DTERelacionado: DetallesDTE?.identificacion?.numeroControl, 
                            fechaEmision: `${DetallesDTE?.identificacion?.fecEmi} ${DetallesDTE?.identificacion?.horEmi}`,
                            fechaDocRel: getFechaCA(DetallesDTE?.identificacion?.fecEmi),
                            tipoGeneracion: 2,
                        },
                    ],
                    cuerpoDocumento: productos.map((producto) => {
                        let precioUni = parseFloat(producto.precio)
                        let impuestoItem = 0
                        let ivaPercibido = 0
                        let ivaRetenido = 0
                        let descuento = 0

                        //CALCULO PRECIO SIN IVA
                        if(producto.conIva){
                            precioUni = parseFloat(producto.precio)/1.13
                        }

                        //CALCULO IVA
                        if(!producto.exento && !producto.noSujeto && !producto.noGravado){
                            impuestoItem = (precioUni * parseFloat(producto.cantidad)) * 0.13

                            //IVA PERCIBIDO
                            if(emisorGranContribuyente && !receptorGranContribuyente && sumaOperaciones >= 100){
                                ivaPercibido = (parseFloat(producto.cantidad) * precioUni) * 0.01
                            }

                            //IVA RETENIDO
                            if(!emisorGranContribuyente && receptorGranContribuyente && sumaOperaciones >= 100){
                                ivaRetenido = (parseFloat(producto.cantidad) * precioUni) * 0.01
                            }
                        }

                        //DESCUENTO
                        switch(producto.tipoDescuento){
                            case 'Porcentaje':
                                descuento = (precioUni * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad)
                                break;
                            case 'Monto':
                                descuento = parseFloat(producto.descuento)
                                break;
                        }

                        return ({
                            numeroDocumento: DetallesDTE?.identificacion?.codigoGeneracion,
                            cantidad: `${parseFloat(producto.cantidad).toFixed(2)}`,
                            precioUni: `${precioUni.toFixed(6)}`,
                            impuesoItem: `${impuestoItem.toFixed(6)}`,
                            impuesoItem2: `${ivaRetenido.toFixed(6)}`,
                            impuesoItem3: `${ivaPercibido.toFixed(6)}`,
                            impuesto: (producto.exento || producto.noSujeto || producto.noGravado) ? '0' : "13",
                            impuesto2: (producto.exento || producto.noSujeto || producto.noGravado) ? '0' : !emisorGranContribuyente && receptorGranContribuyente && sumaOperaciones >= 100 ? '1' : '0',
                            impuesto3: (producto.exento || producto.noSujeto || producto.noGravado) ? '0' : emisorGranContribuyente && !receptorGranContribuyente && sumaOperaciones >= 100 ? '1' : '0',
                            descripcion: producto.descripcion,
                            descuento: isNaN(descuento) ? '0' : `${descuento.toFixed(6)}`,
                            TipoMonto: producto.noGravado ? '3' : producto.exento ? '1' : producto.noSujeto ? '2' : '0',
                            TipoItem: producto.servicio ? '0' : '1',
                            servicioDescuento: producto.servicioDescuento ? '1' : '0',
                            unidad: producto.unidadMedida,
                            descUnidad: unidadesMedida.find((unidad) => unidad.codigo === producto.unidadMedida)?.valor,
                            tributos: producto.noGravado ? [] : (producto.tributos ?? []),
                            ...(producto.noGravado && {
                                noGravado: `${precioUni.toFixed(6)}`,
                            }),
                            codigo: producto.clave ?? '',
                        })
                    }),
                    tributos: resumenTributos,
                    observaciones: formObservaciones.observaciones,
                    referencia: formObservaciones.referencia,
                    mostrarObservacionesPdf: formObservaciones.mostrarObservacionesPdf,
                    incluirObservacionesCorreo: formObservaciones.incluirObservacionesCorreo,
                }],
                tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
                tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
                idSucursal: datos?.sucursal_seleccionada,
                idEmpresa: `${datos?.codigo_empresa}`
            }

            console.log(JSON.stringify(body))
            const response: any = await api_RecepcionDTE(body)
            if(response.body.estado === 'PROCESADO'){
                if(response?.body?.NuevoToken){
                    localStorage.setItem(KEYS.HACIENDA, response?.body?.TokenHacienda)
                    }
                dispatch(getTransactions(formFilter, pagina, true));
                dispatch(handleSetResponseEmitir(response.body))
                dispatch(handleActiveModalEmitido(true))
                dispatch(handleActiveModalEmitir(false))
                dispatch(handleChangeView('Detalle'))
                const qrResponse = await getQR(response.body.JsonFactura)
                if(qrResponse.qr){
                    let qrString = generateQRImageFromBits(qrResponse.qr?.replace("data:image/jpeg;base64,", ""))
                    dispatch(handleSetQRCode(qrString))
                } else {
                    dispatch(generalOpenModalError(qrResponse.message || 'Ocurrió un error al obtener el código QR'))
                }
            }
        } catch (err: any) {
            let message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'

            if(err?.response?.data?.message) message = err.response.data.message
            else {
                try{
                    let messageDesc = err?.response?.data?.body?.descripcionMsg?.replace(/\[(\w+)\.(\w+)\]\s(\w+)/, '$2 de $1 : $3').toUpperCase()
                    message = messageDesc || message
                } catch {
                    message = 'Ocurrió un error al emitir el crédito fiscal, contacta al administrador.'
                }
            }

            dispatch(generalOpenModalError(message))
        } finally {
            dispatch(generalShowLoader(false))
        }
    }

    const calculosProducto = (excluir_idproducto: number = 0) => {
        let sumaOperaciones = 0
        let iva = 0
        let subtotal = 0
        let ivaPercibido = 0
        let ivaRetenido = 0
        let retencionRenta = 0
        let total = 0

        productos.forEach((producto) => {
            let precioUnitario = producto.conIva ? parseFloat(producto.precio)/1.13 : parseFloat(producto.precio)
            let descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (precioUnitario * (parseFloat(producto.descuento)/100)) * parseFloat(producto.cantidad) : parseFloat(producto.descuento)
            let ivaProducto = ((precioUnitario * parseFloat(producto.cantidad)) - descuento) * 0.13

            if (producto.id !== excluir_idproducto) {
                sumaOperaciones += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)

                if(!producto.exento && !producto.noSujeto){
                    iva += ivaProducto
                    subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento) + ivaProducto
                } else {
                    subtotal += ((precioUnitario * parseFloat(producto.cantidad)) - descuento)
                }

                if(!producto.exento && !producto.noSujeto && emisorJuridico){
                    if(emisorGranContribuyente && emisorJuridico && !receptorGranContribuyente){
                        ivaPercibido += parseFloat((subtotal*0.01).toFixed(2))
                    }
                }

                if(!producto.exento && !producto.noSujeto){
                    if(!emisorGranContribuyente && receptorGranContribuyente){
                        ivaRetenido += parseFloat((subtotal*0.01).toFixed(2))
                    }
                }
            }
        })

        if(sumaOperaciones < 100 && (ivaPercibido > 0 || ivaRetenido > 0)) {
            ivaRetenido = 0;
            ivaPercibido = 0;
        }

        total = subtotal + ivaPercibido - ivaRetenido - retencionRenta

        return {
            sumaOperaciones: sumaOperaciones,
            iva: iva,
            subtotal: subtotal,
            ivaPercibido: ivaPercibido,
            ivaRetenido: ivaRetenido,
            retencionRenta: retencionRenta,
            total: total
        }
    }

    const setTotalOriginalNota = (value: number) => {
        dispatch(handleSetTotalOriginal(value));
    }

    useEffect(() => {
        let precioUnitario = formProducto.conIva ? parseFloat(formProducto.precio)/1.13 : parseFloat(formProducto.precio)
        let descuento = 0
        if(formProducto.tipoDescuento === 'Porcentaje'){
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : (precioUnitario * parseFloat(formProducto.descuento)/100) * parseFloat(formProducto.cantidad)
        } else {
            descuento = isNaN(parseFloat(formProducto.descuento)) ? 0 : parseFloat(formProducto.descuento)
        }
        let neto = (parseFloat(formProducto.cantidad) * precioUnitario) 
        let subtotal = neto - descuento
        let iva = subtotal * 0.13
        if(formProducto.exento) iva = 0

        let total = subtotal + iva
        dispatch(handleCalculosProducto({
            neto: isNaN(neto) ? '$0.00' : neto.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            subtotal: isNaN(subtotal) ? '$0.00' : subtotal.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            descuento: isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            total: isNaN(total) ? '$0.00' : total.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'}),
            iva: isNaN(iva) ? '$0.00' : iva.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: 2, style: 'currency', currency: 'USD'})
        }))
    }, [formProducto])

    useEffect(() => {
        if(formProducto.exento){
            dispatch(handleSetFormProducto({
                ...formProducto,
                conIva: false,
            }))
        }
    }, [formProducto.exento])

    useEffect(() => {
        if(formProducto.conIva){
            dispatch(handleSetFormProducto({
                ...formProducto,
                exento: false,
            }))
        }
    }, [formProducto.conIva])


    useEffect(() => {
        if(Array.isArray(formCliente.datosSucursal) && formCliente.datosSucursal.length > 0) cargarDatosIniciales()
        else if (formCliente.loadedSucursal) {
            dispatch(showMessageSucursalVacia('Nota de crédito'));
            history.push('/history-invoice?reload=0');
            dispatch(handleRestarFlujoCredito());
        }
    }, [formCliente.datosSucursal, formCliente.loadedSucursal])

    useEffect(() => {
        if(formProducto.descuento){
            validateFormProducto('descuento', formProducto.descuento)
        }
    }, [formProducto])

    useEffect(() => {
        if(productoEdit.descuento){
            validateFormProductoEdit('descuento', productoEdit.descuento)
        }
    }, [productoEdit])

    return {
        cargarSucursales,
        cargarDatosIniciales,
        cargarProductosIniciales,

        onChangeFormCliente,
        validateFormCliente,

        onChangeFormProducto,
        validateFormProducto,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,
        button_onClickQuitarTodo,
        button_onBack,

        footer_onClickBack,
        footer_onClickNext,
        footer_textButtons,

        actionButton_editar,
        actionButton_eliminarProducto,

        modal_cerrarQuitarTodo,
        modal_cerrarModalEditar,
        modal_cerrarModalEliminar,
        modal_cerrarEmitir,
        modal_cerrarMasOpciones,
        modal_cerrarImprimir,
        modal_cerrarAnular,

        modal_button_onConfirmEdit,
        modal_button_onConfirmEliminar,
        modal_button_emitirDocumento,
        modal_button_emitirNuevo,
        modal_button_verDetalle,
        modal_button_cerrarModalEmitido,    
        modal_button_enviarCorreo,
        modal_button_cerrarEnviarCorreo,
        modal_button_onClickEnviarCorreo,
        modal_button_descargarExcel,
        modal_button_descargarImagen,
        modal_button_descargarPDF,
        modal_button_imprimir,
        modal_button_imprimirTicket,
        modal_button_descargarPDFTicket,
        modal_button_anular,
        modal_button_onConfirmAnular,
        modal_button_descargarJson,

        modal_onChangeFormProductoEdit,
        setTotalOriginalNota,
    }
}

const handleSetFormCliente = (form: any):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_SET_FORM_CLIENTE, payload: form})
const handleErrorsFormCliente = (errors: any):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_HANDLE_ERRORS_CLIENTE, payload:errors})
const handleSetFormProducto = (form: any):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_SET_FORM_PRODUCTO, payload: form})
const handleErrorsFormProducto = (errors: any):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_HANDLE_ERRORS_PRODUCTO, payload:errors})
const handleCalculosProducto = (calculos: any):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_SET_CALCULOS_PRODUCTO, payload: calculos})
const handleAddProducto = (productos: any):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_SET_PRODUCTOS, payload: productos})
const handleRestartFormProducto = ():ActionNC => ({type: NOTA_CREDITO_TYPES.NC_RESTART_FORM_PRODUCTO, payload: null})
const handleSetTotalOriginal = (total: number):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_SET_TOTAL_ORIGINAL, payload: total})
const handleChangeView = (view: string):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_SET_VIEW, payload: view})
const handleActiveModalQuitarTodo = (active: boolean):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_ACTIVE_MODAL_QUITAR_TODO, payload: active})
const handleActiveModalEditar = (active: boolean):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_ACTIVE_MODAL_EDITAR_PRODUCTO, payload: active})
const handleActiveModalEliminar = (active: boolean):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_ACTIVE_MODAL_ELIMINAR_PRODUCTO, payload: active})
const handleActiveModalEmitir = (active: boolean):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_ACTIVE_MODAL_EMITIR, payload: active})
const handleActiveModalEmitido = (active: boolean):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_ACTIVE_MODAL_EMITIDO, payload: active})
const handleActiveModalMasOpciones = (active: boolean):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_ACTIVE_MODAL_MAS_OPCIONES, payload: active})
const handleActiveModalCorreo = (active: boolean):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_ACTIVE_MODAL_ENVIAR_CORREO, payload: active})
const handleActiveModalImprimir = (active: boolean):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_ACTIVE_MODAL_IMPRIMIR, payload: active})
const handleActiveModalAnular = (active: boolean):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_ACTIVE_MODAL_ANULAR, payload: active})
const handleSetProductoEdit = (producto: any):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_SET_PRODUCTO_EDIT, payload: producto})
const handleSetIndexProductoEdit = (index: any):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_SET_PRODUCTO_INDEX, payload: index})
const handleSetResponseEmitir = (response: any):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_SET_RESPONSE_EMITIR, payload: response})
const handleSetQRCode = (qr: any):ActionNC => ({type: NOTA_CREDITO_TYPES.NC_SET_QR_CODE, payload: qr})

export const handleRestarFlujoCredito = ():ActionNC => ({type: NOTA_CREDITO_TYPES.NC_RESTART_ALL, payload: true})

const api_getSucursales = (body: any) => http.post(ENDPOINTS.GESTION_USUARIO_POST_SUCURSALES, body, {}, KEYS.TOKEN)
const api_RecepcionDTE = (body: any) => http.post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)